import { MarvColor, MarvColorPrimary, MarvColorSecondary, MarvColorPurple, MarvColorBlue, MarvColorGreen, MarvColorOrange, MarvColorRed } from '@marv/types';
import { MarvDateService } from '@marv/services';

enum Status {    
    NONE, PENDING_VALIDATION, VALIDATED, PREASSIGNED, ASSIGNED, EMPTY, IN_PROGRESS, FULFILLED, CANCELED, REJECTED    
}

export class MissionStatus {
   
   static readonly Status = Status;
   code: Status;
   name: string;
   icon: string;
   color: MarvColor = MarvColorPrimary;
   
   constructor(status: Status, day: number = -1){
       this.code = status;
       this.init(day);
   }
   
   static FromOrder(status: string, day: number): MissionStatus {
        let missionStatus: Status = Status.NONE;
        switch(status){
            case "PENDING_VALIDATION" :
                missionStatus = Status.PENDING_VALIDATION ;
                break;
            case "VALIDATED" :
                missionStatus = Status.VALIDATED;
                break;
            case "ASSIGNED" :
                missionStatus = Status.ASSIGNED;
                break;
            case "REJECTED" :
                missionStatus = Status.REJECTED;
                break;
            case "IN_PROGRESS" :
                missionStatus = Status.IN_PROGRESS;
                break;
            case "FULFILLED" :
                missionStatus = Status.FULFILLED;
                break;
            case "CANCELED" :
                missionStatus = Status.CANCELED;
                break;
        }
        return new MissionStatus(missionStatus, day);  
    }
    
    static FromPearlsPlanningEntry(status: string, day: number): MissionStatus {
        let missionStatus: Status = Status.NONE;
        switch(status){
            case "EMPTY" :                
                missionStatus = Status.EMPTY;
                break;
            case "COMPLETE" :
                missionStatus = Status.FULFILLED;
                break;
            case "WIP" :
                missionStatus = Status.IN_PROGRESS;
                break;           
        }
        return new MissionStatus(missionStatus, day);  
    }
   
    init(day: number) {
        let name = '';
        let icon = '';
        let color:MarvColor = MarvColorPrimary;
        switch(this.code){
            case Status.PENDING_VALIDATION :
                name = "MISSION_STATUS_PENDING_VALIDATION";
                icon = "hourglass-outline";
                color = MarvColorSecondary;
                break;
            case Status.VALIDATED :
                name = "MISSION_STATUS_VALIDATED";
                icon = "checkmark-circle-outline";
                color = MarvColorBlue;
                break;
            case Status.ASSIGNED :            
                name = "MISSION_STATUS_ASSIGNED";
                icon = "checkmark-circle-outline";
                color = MarvColorBlue;
                let today = MarvDateService.GetToday();              
                if(day === today){
                    this.code = Status.IN_PROGRESS;
                    name = "MISSION_STATUS_IN_PROGRESS";
                    icon = "hourglass-outline";
                    color = MarvColorOrange;
                }
                break;
            case Status.REJECTED :
                name = "MISSION_STATUS_REJECTED";
                icon = "close-circle-outline";
                color = MarvColorRed;
                break;
            case Status.EMPTY :
                name = "MISSION_STATUS_EMPTY";
                icon = "time-outline";
                color = MarvColorBlue;
                break;
            case Status.IN_PROGRESS :
                name = "MISSION_STATUS_IN_PROGRESS";
                icon = "hourglass-outline";
                color = MarvColorPurple;
                break;
            case Status.FULFILLED :
                name = "MISSION_STATUS_FULFILLED";
                icon = "checkmark-circle-outline";
                color = MarvColorGreen;
                break;
            case Status.CANCELED :
                name = "MISSION_STATUS_CANCELED";
                icon = "warning-outline";
                color = MarvColorRed;
                break;
        }       
        this.name = name;
        this.icon = icon;
        this.color = color;
    }
       
}


